import { render } from "./Inventory_Transfer_Dialog.vue?vue&type=template&id=a744eaba&scoped=true&ts=true"
import script from "./Inventory_Transfer_Dialog.vue?vue&type=script&lang=ts"
export * from "./Inventory_Transfer_Dialog.vue?vue&type=script&lang=ts"

import "./Inventory_Transfer_Dialog.vue?vue&type=style&index=0&id=a744eaba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a744eaba"]])

export default __exports__